// extracted by mini-css-extract-plugin
export default {"listHeader":"IncidentList_listHeader__eDG9a","list":"IncidentList_list__+zufT"};